import React, { useContext } from "react";
import Layout from "../../components/Layout/Layout";
import LContainer from "../../components/LContainer/LContainer";
import BaseProductForm from "../../components/Products/BaseProductForm";
import ProductType, {
    isClientProductType
} from "../../../common/interfaces/enums/ProductType";
import { QuoteGroupContext } from "../../providers/RootContextProvider";
import cx from "classnames";
import { useHistory } from "react-router-dom";
import SettingNavigation from "../../components/SettingNavigation/SettingNavigation";
import Icon from "../../../common/components/Icon/Icon";
import { createOrSetClientsAPI } from "../../api/api";
import { IClient } from "../../../common/interfaces/IClient";
import ClientDetailsSection from "../../components/Clients/ClientDetailsSection/ClientDetailsSection";
import Alert from "../../../common/components/Alert/Alert";
import { Severity } from "../../../common/interfaces/enums/Severity";

const FamilySettingsPage: React.FC = () => {
    const search = new URLSearchParams(location.search);

    const { selectors, actions } = useContext(QuoteGroupContext);
    const history = useHistory();

    const isEditing = search.has("edit") || selectors.hasCreatedQuote();

    return (
        <Layout
            hideMenu={!isEditing}
            progressBarCurrentStage={"build"}>
            <BaseProductForm
                clients={selectors.getClients()}
                compareProducts={[]}
                settings={selectors.getAllSettings()}
                onSubmit={async (settings, clients) => {
                    const res = await createOrSetClientsAPI(
                        selectors.getGroupId(),
                        clients
                    );

                    const activeClients = res.clients.filter((i: IClient) => i.isActive);
                    actions.setClients(activeClients);
                    actions.populateQuoteConfigs(
                        res.quoteGroupCases.map((s) => s.config)
                    );

                    const productTypes = (search.getAll(
                        "product"
                    ) as ProductType[]).filter(isClientProductType);

                    const paramBuilder = new URLSearchParams();
                    productTypes.forEach((s) => {
                        paramBuilder.append("product", s);
                    });

                    history.push(`/products?${paramBuilder.toString()}`);
                }}>
                {({ handleSubmit, submitCount, isValid, isSubmitting }) => {
                    return (
                        <React.Fragment>
                            <div className={cx("layout-flex-column--centered")}>
                                <LContainer
                                    className={cx(
                                        "panel-setting",
                                        "layout-flex-column--centered"
                                    )}>
                                    <Icon id="SettingsPeople" />
                                    <h2 className="text-primary text-align--center gap-4xl">
                                        Who needs cover?
                                    </h2>
                                    <ClientDetailsSection />
                                </LContainer>
                            </div>
                            <div className="layout-flex-row--justify-centered">
                                <Alert
                                    severity={Severity.Info}
                                    isFitContent
                                    className="gap-pre-2xl gap-m">
                                    <span className="text-primary text-bold text-font-size-s text-paragraph">
                                        LifeDirect&apos;s service is FREE and doesn&apos;t
                                        affect the price of your policy
                                    </span>
                                </Alert>
                            </div>
                            <SettingNavigation
                                onClickCallToAction={handleSubmit}
                                onClickBack={
                                    isEditing ? () => history.push("/results") : undefined
                                }
                                isDisabledCallToAction={submitCount > 0 && !isValid}
                                isLoading={isSubmitting}
                                gaAttributes={{
                                    action: "family"
                                }}
                                isEditing={isEditing}
                            />
                        </React.Fragment>
                    );
                }}
            </BaseProductForm>
        </Layout>
    );
};

export default FamilySettingsPage;
